function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHestiaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "85.89 50.15 340.23 411.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -52.291,
    y1: -474.658,
    x2: 23.383,
    y2: -474.658,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2a255c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#672783"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#652782"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    style: {
      stopColor: "#60277d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#562674"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    style: {
      stopColor: "#4a2568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3f245d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.89 407.196s23.994-10.283 74.837-112.255c11.426-22.851 19.138-37.704 30.849-47.987 0 0 19.709-1.428 10.283 30.563s-12.854 85.12-12.854 85.12-27.42 57.698-31.42 61.983c-3.999 4.284-17.995 25.707-44.273 21.994-26.279-3.714-27.422-39.418-27.422-39.418z",
    style: {
      fill: "url(#a)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -52.291,
    y1: -474.658,
    x2: 23.383,
    y2: -474.658,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20254b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    style: {
      stopColor: "#3c2758",
      stopOpacity: 0.8714
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#5a2867",
      stopOpacity: 0.7045
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    style: {
      stopColor: "#732673",
      stopOpacity: 0.5343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    style: {
      stopColor: "#86237b",
      stopOpacity: 0.3619
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    style: {
      stopColor: "#922180",
      stopOpacity: 0.1857
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#952081",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.89 407.196s23.994-10.283 74.837-112.255c11.426-22.566 19.138-37.704 30.849-47.987 0 0 19.709-1.428 10.283 30.563s-12.854 85.12-12.854 85.12-27.42 57.698-31.42 61.983c-3.999 4.284-17.995 25.707-44.273 21.994-26.279-3.714-27.422-39.418-27.422-39.418z",
    style: {
      fill: "url(#b)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: -52.291,
    y1: -473.336,
    x2: 10.502,
    y2: -473.336,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#952081",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    style: {
      stopColor: "#962081",
      stopOpacity: 0.01289326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    style: {
      stopColor: "#a02985",
      stopOpacity: 0.2279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#a52e86",
      stopOpacity: 0.4982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a72f87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.014 376.061c-29.42 61.127-39.99 49.701-39.99 49.701s-13.995-1.714-28.277-4.57c3.142 10.283 9.997 22.85 25.136 25.136 26.278 3.713 40.275-17.71 44.273-21.994 4-4.285 31.42-61.983 31.42-61.983s2.571-42.56 9.998-74.266c-11.426 21.423-25.993 53.414-42.56 87.976z",
    style: {
      opacity: 0.43,
      fill: "url(#c)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: -58.722,
    y1: -507.943,
    x2: 67.436,
    y2: -507.943,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2271b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#3aabe2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#71c7d7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.907 50.15s100.544-2.856 91.118 161.385c-9.997 176.237 13.425 243.933 49.986 198.232 0 0-36.847 75.693-105.114 35.133-40.275-23.708-42.274-64.554-41.989-113.684 0 0 11.997-160.527 5.999-281.066z",
    style: {
      fill: "url(#d)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: -22.171,
    y1: -396.168,
    x2: -22.171,
    y2: -436.435,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d70953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a21a5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a21a5c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.559 383.202s23.993 66.84 103.686 47.416c.856-.286 1.142.857.57 1.428-9.425 5.999-25.706 13.996-40.274 19.71-43.702 16.566-59.698-38.276-63.982-68.554z",
    style: {
      fill: "url(#e)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: -21.967,
    y1: -396.168,
    x2: -21.967,
    y2: -436.435,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d70953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#3a1e3e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.559 383.202s23.993 66.84 103.686 47.416c.856-.286 1.142.857.57 1.428-9.425 5.999-32.276 18.852-46.558 20.566-46.559 5.427-53.414-39.132-57.698-69.41z",
    style: {
      fill: "url(#f)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: -38.382,
    y1: -440.96,
    x2: 32.63,
    y2: -440.96,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e72273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#d70953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a21a5c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.277 237.528c-23.423-16.567-51.415 11.14-51.415 11.14 24.85-9.712-9.712 55.699 2 134.534 8.283 55.985 50.843 71.98 50.843 71.98 37.704 16.282 76.836-3.713 76.836-3.713-113.398-10.282-35.133-182.807-78.264-213.941Z",
    style: {
      fill: "url(#g)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: -38.382,
    y1: -440.96,
    x2: 32.729,
    y2: -440.96,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e72273",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    style: {
      stopColor: "#e72871",
      stopOpacity: 0.4418
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#e72a70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#e42a6f",
      stopOpacity: 0.7974
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    style: {
      stopColor: "#db276c",
      stopOpacity: 0.5856
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    style: {
      stopColor: "#cb2367",
      stopOpacity: 0.3694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    style: {
      stopColor: "#b51e61",
      stopOpacity: 0.1515
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a21a5c",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.277 237.528c-23.137-17.71-51.415 11.14-51.415 11.14 24.85-9.712-9.712 55.699 2 134.534 8.283 55.985 50.843 71.98 50.843 71.98 37.704 16.282 76.836-3.713 76.836-3.713-113.398-10.282-36.561-177.951-78.264-213.941Z",
    style: {
      fill: "url(#h)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: -58.722,
    y1: -507.943,
    x2: 65.881,
    y2: -507.943,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#046ab3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    style: {
      stopColor: "#198fcf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009ac6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.611 263.235C141.608 76.143 91.907 50.15 91.907 50.15c7.14 107.97-5.999 281.066-5.999 281.066-.285 51.13 1.714 89.976 41.703 113.97 68.267 40.274 105.115-35.134 105.115-35.134-47.13 84.263-119.968 46.559-105.115-146.817z",
    style: {
      fill: "url(#i)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: -38.382,
    y1: -440.96,
    x2: 29.004,
    y2: -440.96,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e72273",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    style: {
      stopColor: "#cf1f6a",
      stopOpacity: 0.2583
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    style: {
      stopColor: "#b71c62",
      stopOpacity: 0.566
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#a81b5e",
      stopOpacity: 0.8243
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a21a5c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.137 264.092c1.714-26.85-15.71-26.85-17.423-26.85-12.854 3.999-20.852 11.711-20.852 11.711 24.85-9.711-9.712 55.7 2 134.535 8.283 55.985 50.843 71.98 50.843 71.98 37.704 16.282 76.836-3.713 76.836-3.713-130.536 46.844-93.117-158.528-91.404-187.663z",
    style: {
      fill: "url(#j)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: -35.675,
    y1: -440.96,
    x2: 32.729,
    y2: -440.96,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e72273",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    style: {
      stopColor: "#e93e7d",
      stopOpacity: 0.03596431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#ee779c",
      stopOpacity: 0.1371
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#f3a1b8",
      stopOpacity: 0.2429
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    style: {
      stopColor: "#f7c1d0",
      stopOpacity: 0.3515
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    style: {
      stopColor: "#fad9e2",
      stopOpacity: 0.4634
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fdeaf0",
      stopOpacity: 0.5798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    style: {
      stopColor: "#fef6f9",
      stopOpacity: 0.7026
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    style: {
      stopColor: "#fffdfe",
      stopOpacity: 0.8361
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#fdfcfc",
      stopOpacity: 0.8808
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    style: {
      stopColor: "#f8f1f4",
      stopOpacity: 0.7561
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    style: {
      stopColor: "#efdfe6",
      stopOpacity: 0.6287
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#e4c5d1",
      stopOpacity: 0.4995
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    style: {
      stopColor: "#d5a4b6",
      stopOpacity: 0.3689
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#c47b96",
      stopOpacity: 0.2371
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    style: {
      stopColor: "#b24a74",
      stopOpacity: 0.1069
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a21a5c",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.862 248.668s7.998-7.713 20.852-11.712c1.713 0 19.137 0 17.423 26.85-1.713 29.135-43.702 234.508 91.69 187.378-113.398-9.997-36.847-177.666-78.55-213.656-23.137-17.71-51.415 11.14-51.415 11.14z",
    style: {
      opacity: 0.17,
      fill: "url(#k)",
      strokeWidth: 2.85636
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: -25.224,
    y1: -453.727,
    x2: 40.939,
    y2: -568.325,
    gradientTransform: "rotate(-68.572 1337.064 -695.33) scale(2.85608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2271b8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#2d75ba",
      stopOpacity: 0.01914263
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    style: {
      stopColor: "#799ace",
      stopOpacity: 0.2215
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    style: {
      stopColor: "#adbcdd",
      stopOpacity: 0.415
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    style: {
      stopColor: "#d1d8e9",
      stopOpacity: 0.5948
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    style: {
      stopColor: "#ebedf0",
      stopOpacity: 0.7577
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#fbfaf4",
      stopOpacity: 0.8981
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fffef5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    style: {
      stopColor: "#fefdf5",
      stopOpacity: 0.7737
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    style: {
      stopColor: "#f6faf3",
      stopOpacity: 0.6085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    style: {
      stopColor: "#e9f4f0",
      stopOpacity: 0.4627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#d6eceb",
      stopOpacity: 0.328
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    style: {
      stopColor: "#bbe1e5",
      stopOpacity: 0.2011
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    style: {
      stopColor: "#96d3de",
      stopOpacity: 0.08162302
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#71c7d7",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.907 50.15s49.7 25.993 35.704 213.085c-11.14 147.96 28.85 204.801 69.41 185.378 12.282-7.14 21.708-17.424 27.707-25.707 2.856-4 5.712-8.57 8.283-13.14-36.561 45.417-59.983-21.994-49.986-198.231C192.45 47.294 91.907 50.15 91.907 50.15Z",
    style: {
      opacity: 0.25,
      fill: "url(#l)",
      strokeWidth: 2.85636
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHestiaLogo);
export default __webpack_public_path__ + "static/media/hestia-logo.ccc9f51357d0abe61257314731426345.svg";
export { ForwardRef as ReactComponent };